// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/rainy-day.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const rainyDay: Score = {
  slug: "rainy-day",
  n: 20,
  title: "Rainy Day",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 84,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 69,
  highest: 76,
  hasLyrics: false,
  jasonNote: "Everything here sits under one hand, just like First Steps \u2014 but starting on A instead of C. Nothing new for your fingers. Listen to what happens to the mood.",
  teaches: ["the minor sound", "five-finger position on A", "the same shape in a new place"],
  art: "/sight-reading/art/rainy-day.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/rainy-day.jpg",
  newForThisEdition: true,
  fillsGap: "No piece in the printed book is in a minor key.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 74, pitch: "D5", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 2.0, midi: 71, pitch: "B4", d: "half" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 72, pitch: "C5", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 71, pitch: "B4", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 2.0, midi: 74, pitch: "D5", d: "half" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 69, pitch: "A4", d: "whole" },
  ],
};
